
import React from 'react';

import { Dialog } from '../../../../base/dialog';
import { translate } from '../../../../base/i18n';
import { connect } from '../../../../base/redux';
import AbstractRecordingConsentDialog, {
    mapStateToProps
} from '../AbstractRecordingConsentDialog';

const styles = {
    container: {
        padding: '16px 0'
    },
    message: {
        marginBottom: '16px',
        fontSize: '14px',
        lineHeight: '1.5'
    },
    disclaimer: {
        marginBottom: '0',
        fontSize: '12px',
        color: '#666',
        lineHeight: '1.4'
    }
};

/**
 * React Component for getting consent from participants before recording starts.
 *
 * @augments Component
 */
class RecordingConsentDialog extends AbstractRecordingConsentDialog {
    /**
   * Initializes a new Recording Concent Dialog instance.
   *
   * @param {Object} props - The read-only properties with which the new
   * instance is to be initialized.
   */
    constructor(props) {
        super(props);
        this.state = {
            title: 'recording.consentDialog.title',
            message: 'recording.consentDialog.message',
            disclaimer: 'recording.consentDialog.disclaimer'
        };
    }

    /**
     * Implements React's {@link Component#componentDidMount()}.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentDidMount() {
        this._updateDialogContent();
    }

    /**
     * Implements React's {@link Component#componentDidUpdate()}.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentDidUpdate(prevProps) {
        // Update dialog content if mode or recording state has changed
        if (prevProps.mode !== this.props.mode
            || prevProps._isRecordingandLivestreamingOn !== this.props._isRecordingandLivestreamingOn) {
            this._updateDialogContent();
        }
    }

    /**
     * Updates the dialog content based on the current recording mode.
     *
     * @private
     * @returns {void}
     */
    _updateDialogContent() {
        const labelKey = this._getLabelKey();

        if (labelKey === 'recording.live') {
            this.setState({
                title: 'recording.livestreamconsentDialog.title',
                message: 'recording.livestreamconsentDialog.message',
                disclaimer: 'recording.livestreamconsentDialog.disclaimer'
            });
        } else if (labelKey === 'recording.recLive') {
            this.setState({
                title: 'recording.recliveconsentDialog.title',
                message: 'recording.recliveconsentDialog.message',
                disclaimer: 'recording.recliveconsentDialog.disclaimer'
            });
        } else {
            this.setState({
                title: 'recording.consentDialog.title',
                message: 'recording.consentDialog.message',
                disclaimer: 'recording.consentDialog.disclaimer'
            });
        }
    }

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { t } = this.props;

        return (
            <Dialog
                cancelKey = 'recording.consentDialog.leaveMeeting'
                disableBlanketClickDismiss = { true }
                disableCloseIcon = { true }
                disableOverlay = { true }
                hideCloseButton = { true }
                okKey = 'recording.consentDialog.accept'
                onCancel = { this._onDecline }
                onSubmit = { this._onAccept }
                titleKey = { this.state.title }
                width = 'small'>
                <div style = { styles.container }>
                    <p style = { styles.message }>
                        {t(this.state.message)}
                    </p>
                    <p style = { styles.disclaimer }>
                        {t(this.state.disclaimer)}
                    </p>
                </div>
            </Dialog>
        );
    }


    _getLabelKey: () => ?string;

    _onAccept: () => boolean;
    _onDecline: () => boolean;
}

export default translate(connect(mapStateToProps)(RecordingConsentDialog));
